import './App.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import JupyterNotebook from './Components/JupyterNotebook';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import NavbarComp from './Common/Navbar/Navbar';
import Workflow from './Components/Workflow';
function App() {
  return (
    <BrowserRouter>
      <div className="App">

        <Routes>
          <Route path='/' element={<div><NavbarComp />Home</div>} />
          <Route path="notebook" element={<JupyterNotebook />} />
          <Route path="workflow" element={<Workflow />} />
          <Route path='*' element={<div>Error</div>} />
        </Routes>
        {/* <JupyterNotebook /> */}
      </div>
    </BrowserRouter>
  );
}

export default App;
